import { routes } from "src/constants/routes.constants.ts";

export const dashboardRoute = {
  path: routes.admin.dashboard.root,
  lazy: () => import("src/admin/dashboard/dashboard.tsx"),
};
